export default "__VITE_ASSET__DHngaMU2__"